$mol_link_lazy $mol_link
	uri? \
	uri_generated \
	current false
	event *
		^
		mousedown? <=> generate? null
